import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {CHART_TYPE, DataBase} from './data-base';
import {DataTupla} from './data-tupla';

@jsonObject
export class DataRow extends DataBase {
  @jsonArrayMember(DataTupla)
  private gwtTuplas: DataTupla[] = [];
  @jsonMember
  private level: number;
  @jsonMember
  private note: string;
  @jsonMember
  private units: string;
  @jsonMember
  private unitsLevel: number;
  @jsonMember
  private selectable: boolean;
  @jsonMember
  private rangeEnabled: boolean;
  @jsonMember
  private rangeMin: number = null;
  @jsonMember
  private rangeMax: number = null;
  @jsonMember
  private color: string;

  // link to tables
  @jsonMember
  private gridId: string = null;
  @jsonMember
  private gridId2: string = null;

  // tooltip link
  @jsonMember
  private tooltipLink: string = null;
  @jsonMember
  private tooltipLinkDescription: string = null;

  @jsonMember
  private cssFormat: string;

  @jsonMember
  private chartEnabled: boolean;
  @jsonMember
  private hasChildren: boolean; // indicate if row has children
  @jsonMember
  private defaultChartType: string;


  // Work attributes
  // tslint:disable-next-line:variable-name
  private _selected = false;


  // Getter and setter

  public get Note(): string {
    return this.note;
  }
  public get DefaultChartType(): CHART_TYPE {
    return CHART_TYPE[this.defaultChartType];
  }

  public get DataTuplas(): DataTupla[] {
    return this.gwtTuplas;
  }

  public get GridId(): string {
    return this.gridId;
  }
  public get GridId2(): string {
    return this.gridId2;
  }
  public get CssFormat(): string {
    if (this.cssFormat === null || this.cssFormat === undefined) {
      return '';
    } else {
      return this.cssFormat;
    }
  }
  public get Selectable(): boolean {
    if (this.selectable === null || this.selectable === undefined) {
      return false;
    }

    return this.selectable;
  }
  public getDataTupla(tuplaId: string): DataTupla {
    return this.DataTuplas.find(x => x.Id === tuplaId);
  }

  public getTuplaValue(tuplaId: string, defaultValue: string): any {
    const tupla: DataTupla = this.getDataTupla(tuplaId);
    if (tupla === undefined) {
      // tupla description not found use id
      return defaultValue;
    } else {
      return tupla.Value;
    }
  }
  get Units(): string {
    return this.units !== undefined && this.units !== null ? this.units : '';
  }
  get selected(): boolean {
    return this._selected;
  }
  set selected(value: boolean) {
    if (this.Selectable) {
      this._selected = value;
    }
  }

  get Description(): string {
    return this.getTuplaValue('Description', this.Id);
  }

  get Level(): number {
    return this.level;
  }
  public swapSelected(): void {
    if (this.Selectable) {
      this._selected = !this.selected;
    }
  }

  /**
   * Return colspan value:
   * 0: no collspan
   * -1: col to not display
   * > 0: colspan to set
   * @param tuplaIdx
   */
  public getColSpan(tuplaIdx: number): number {
    // rowspan not set: default 0
    if (this.gwtTuplas[tuplaIdx].Rowspan === undefined || this.gwtTuplas[tuplaIdx].Rowspan !== 1) {
      return 0;
    }

    // rowspan is set ( = 1) check if it's the first
    if (tuplaIdx === 0 || this.gwtTuplas[tuplaIdx - 1].Rowspan !== 1) {
      // it's the first: count tuplas
      let colspan = 1;
      for (let idx = tuplaIdx + 1; idx < this.gwtTuplas.length && this.gwtTuplas[idx].Rowspan === 1; idx++ ) {
        colspan++;
      }
      return colspan;
    }
    // it isn't first
    return -1;
  }
}
